module.exports = __webpack_public_path__ + "static/leads-img-1-89a64ea8b6d8ccae7853bb57d00cf90a.jpg";